<template>
  <v-container fluid tag="section">
    <div class="my-3 white rounded-md pa-3">
      <v-row>
        <v-col cols="12" md='4'>
          <v-select-search
            hide-details
            outlined dense
            label="年份选择"
            :data='yearItems'
            @on-change="statis"
            item-text="label"
            item-value="value"
            v-model='form.year'>
          </v-select-search>
        </v-col>
      </v-row>
    </div>
    <v-card :loading="loading" class="elevation-0 my-3 overflow-x-auto">
      <v-card-title>
        部门绩效目标完成情况
      </v-card-title>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">部门名称</th>
              <th class="text-left">一月</th>
              <th class="text-left">二月</th>
              <th class="text-left">三月</th>
              <th class="text-left">四月</th>
              <th class="text-left">五月</th>
              <th class="text-left">六月</th>
              <th class="text-left">七月</th>
              <th class="text-left">八月</th>
              <th class="text-left">九月</th>
              <th class="text-left">十月</th>
              <th class="text-left">十一月</th>
              <th class="text-left">十二月</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, idx) in targets" v-if="item.setType === 2 || item.setType === 4">
              <tr :key="idx">
                <td :class="tdClass">
                  <v-chip v-if="item.setDepts.length === 1" small class="px-1" color="primary">
                  {{item.setDepts[0].id === 1 ? '源点集团' : item.setDepts[0].name | cutLongStr}}
                  </v-chip>
                  <v-tooltip v-else-if="item.setDepts.length > 1" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">其他{{item.setDepts.length}}部</span>
                    </template>
                    <span  v-for='(u, index) in item.setDepts' :key="index">
                      {{u.name | cutLongStr}}
                      <strong v-if="index < item.setDepts.length -1">/</strong>
                    </span>
                  </v-tooltip>
                </td>
                <td :class="tdClass">
                  <strong :class="targetClass">目标：{{ item.januaryTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.januarySignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.januaryStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear class="mb-2" rounded :height="progressHeight" :color="item.januaryRate | fmRateColor" :value="item.januaryRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td :class="tdClass">
                  <strong :class="targetClass">目标：{{ item.februaryTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.februarySignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.februaryStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear class="mb-2" rounded :height="progressHeight" :color="item.februaryRate | fmRateColor" :value="item.februaryRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td :class="tdClass">
                  <strong :class="targetClass">目标：{{ item.marchTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.marchSignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.marchStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear class="mb-2" rounded :height="progressHeight" :color="item.marchRate | fmRateColor" :value="item.marchRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td :class="tdClass">
                  <strong :class="targetClass">目标：{{ item.aprilTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.aprilSignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.aprilStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear rounded :height="progressHeight" :color="item.aprilRate | fmRateColor" :value="item.aprilRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td :class="tdClass">
                  <strong :class="targetClass">目标：{{ item.mayTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.maySignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.mayStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear rounded :height="progressHeight" :color="item.mayRate | fmRateColor" :value="item.mayRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td :class="tdClass">
                  <strong :class="targetClass">目标：{{ item.juneTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.juneSignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.juneStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear rounded :height="progressHeight" :color="item.juneRate | fmRateColor" :value="item.juneRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td :class="tdClass">
                  <strong :class="targetClass">目标：{{ item.julyTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.julySignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.julyStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear rounded :height="progressHeight" :color="item.julyRate | fmRateColor" :value="item.julyRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td :class="tdClass">
                  <strong :class="targetClass">目标：{{ item.augustTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.augustSignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.augustStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear rounded :height="progressHeight" :color="item.augustRate | fmRateColor" :value="item.augustRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td :class="tdClass">
                  <strong :class="targetClass">目标：{{ item.septemberTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.septemberSignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.septemberStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear rounded :height="progressHeight" :color="item.septemberRate | fmRateColor" :value="item.septemberRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td :class="tdClass">
                  <strong :class="targetClass">目标：{{ item.octoberTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.octoberSignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.octoberStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear rounded :height="progressHeight" :color="item.octoberRate | fmRateColor" :value="item.octoberRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td :class="tdClass">
                  <strong :class="targetClass">目标：{{ item.novemberTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.novemberSignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.novemberStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear rounded :height="progressHeight" :color="item.novemberRate | fmRateColor" :value="item.novemberRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td :class="tdClass">
                  <strong :class="targetClass">目标：{{ item.decemberTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.decemberSignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.decemberStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear rounded :height="progressHeight" :color="item.decemberRate | fmRateColor" :value="item.decemberRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
              </tr>
              <tr :key="`idx-${idx}`">
                <td colspan="13">
                  <v-card-title class="pa-0 size-13">
                    完成：{{Math.ceil(item.allSignPrice)}}（一壹类：{{Math.ceil(item.allStateOneSignPrice)}}）
                    <v-spacer></v-spacer>
                    目标：{{item.yearTarget}}
                  </v-card-title>
                  <v-progress-linear :color="item.allSignPrice/item.yearTarget * 100 | fmRateColor" rounded :height="progressHeight" :value="item.allSignPrice/item.yearTarget * 100" class="mb-2" striped>
                      <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
    <v-card :loading="loading" class="elevation-0">
      <v-card-title>
        个人绩效目标完成情况
      </v-card-title>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">人员姓名</th>
              <th class="text-left">一月</th>
              <th class="text-left">二月</th>
              <th class="text-left">三月</th>
              <th class="text-left">四月</th>
              <th class="text-left">五月</th>
              <th class="text-left">六月</th>
              <th class="text-left">七月</th>
              <th class="text-left">八月</th>
              <th class="text-left">九月</th>
              <th class="text-left">十月</th>
              <th class="text-left">十一月</th>
              <th class="text-left">十二月</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, idx) in targets" v-if="item.setType === 1">
              <tr  :key="idx">
                <td style="width:90px">
                  <v-chip v-for='(u, index) in item.setUsers' class="px-1" small color="primary" :key="index">
                    {{u.name}}
                    <strong v-if="index < item.setUsers.length -1">/</strong>
                  </v-chip>
                </td>
                <td>
                  <strong :class="targetClass">目标：{{ item.januaryTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.januarySignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.januaryStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear class="mb-2" rounded :height="progressHeight" :color="item.januaryRate | fmRateColor" :value="item.januaryRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td>
                  <strong :class="targetClass">目标：{{ item.februaryTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.februarySignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.februaryStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear class="mb-2" rounded :height="progressHeight" :color="item.februaryRate | fmRateColor" :value="item.februaryRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td>
                  <strong :class="targetClass">目标：{{ item.marchTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.marchSignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.marchStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear class="mb-2" rounded :height="progressHeight" :color="item.marchRate | fmRateColor" :value="item.marchRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td>
                  <strong :class="targetClass">目标：{{ item.aprilTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.aprilSignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.aprilStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear rounded :height="progressHeight" :color="item.aprilRate | fmRateColor" :value="item.aprilRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td>
                  <strong :class="targetClass">目标：{{ item.mayTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.maySignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.mayStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear rounded :height="progressHeight" :color="item.mayRate | fmRateColor" :value="item.mayRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td>
                  <strong :class="targetClass">目标：{{ item.juneTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.juneSignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.juneStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear rounded :height="progressHeight" :color="item.juneRate | fmRateColor" :value="item.juneRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td>
                  <strong :class="targetClass">目标：{{ item.julyTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.julySignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.julyStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear rounded :height="progressHeight" :color="item.julyRate | fmRateColor" :value="item.julyRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td>
                  <strong :class="targetClass">目标：{{ item.augustTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.augustSignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.augustStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear rounded :height="progressHeight" :color="item.augustRate | fmRateColor" :value="item.augustRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td>
                  <strong :class="targetClass">目标：{{ item.septemberTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.septemberSignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.septemberStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear rounded :height="progressHeight" :color="item.septemberRate | fmRateColor" :value="item.septemberRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td>
                  <strong :class="targetClass">目标：{{ item.octoberTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.octoberSignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.octoberStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear rounded :height="progressHeight" :color="item.octoberRate | fmRateColor" :value="item.octoberRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td>
                  <strong :class="targetClass">目标：{{ item.novemberTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.novemberSignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.novemberStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear rounded :height="progressHeight" :color="item.novemberRate | fmRateColor" :value="item.novemberRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
                <td>
                  <strong :class="targetClass">目标：{{ item.decemberTarget }}</strong><br>
                  <strong :class="finishClass">完成：{{ Math.ceil(item.decemberSignPrice) || 0}}</strong><br>
                  <strong :class="finishClass">一壹类：{{ Math.ceil(item.decemberStateOneSignPrice) || 0}}</strong>
                  <v-progress-linear rounded :height="progressHeight" :color="item.decemberRate | fmRateColor" :value="item.decemberRate" striped>
                    <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
              </tr>
              <tr :key="`idx-${idx}`">
                <td colspan="13">
                  <v-card-title class="pa-0 size-13">
                    完成：{{Math.ceil(item.allSignPrice)}}（一壹类：{{Math.ceil(item.allStateOneSignPrice)}}）
                    <v-spacer></v-spacer>
                    目标：{{item.yearTarget}}
                  </v-card-title>
                  <v-progress-linear :color="item.allSignPrice/item.yearTarget * 100 | fmRateColor" rounded :height="progressHeight" :value="item.allSignPrice/item.yearTarget * 100" class="mb-2" striped>
                     <template v-slot:default="{ value }">
                      <strong :class="progressClass">{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-container>
</template>

<script>
  import { selectData2 } from '@/utils/tool.js'
  import { statis } from '@/api/statis/target.js'
  import { cutString } from '@/utils/stringUtil.js'
  import VSelectSearch from '@/components/select/v-select-search.vue'

  export default {
    components: {
      VSelectSearch
    },
    name: 'StatisTarget',
    filters: {
      fmRateColor(val) {
        if (val > 0 && val <= 20) {
          return 'deep-orange'
        } else if (val > 20 && val <= 40) {
          return 'orange darken-4'
        } else if (val > 40 && val <= 60) {
          return 'orange'
        } else if (val > 60 && val <= 80) {
          return 'lime darken-4'
        } else if (val > 80 && val <= 90) {
          return 'light-green darken-4'
        } else if (val > 90) {
          return 'green'
        }
        return 'grey'
      },
      cutLongStr (val) {
        return cutString(val, 10)
      }
    },
    data() {
      return {
        loading: false,
        targets: [],
        progressHeight: 13,
        progressClass: 'white--text size-10',
        targetClass: 'size-10 grey--text',
        finishClass: 'size-10',
        tdClass: 'width:120px',
        yearItems: selectData2(),
        form: {
          year: Number(this.$moment().format('YYYY'))
        }
      }
    },
    methods: {
      statis() {
        this.loading = true
        statis(this.form).then(res => {
          if (res.status === 200) {
            this.setData(res.data)
          }
          this.loading = false
        })
      },
      setData(data) {
        const this_ = this
        this_.targets = []
        data.targets.forEach(tar => {
          tar.allSignPrice = 0
          tar.allStateOneSignPrice = 0
          const setIdArr = tar.setIds.split(",")
          data.userAndDeptMonthStatisVos.forEach(s => {
            if (setIdArr.indexOf(s.id.toString()) !== -1) {
              this.setMonth(tar, s)
            }
          })
          this.setOther(data.userAndDeptMonthStatisVos, tar, setIdArr)
          this.targets = data.targets
        })
      },
      setOther(udp, tar, setIdArr) {
        if (setIdArr.length > 1) {
          setIdArr.forEach((id, idx) => {
            udp.forEach(s => {
              const { month, signPrice, stateOneSignPrice } = s
              if (Number(s.id) === Number(id)) {
                if (Number(month) === 1) {
                  tar.januarySignPrice = idx === 0 ? 0 : tar.januarySignPrice
                  tar.januarySignPrice += signPrice
                  tar.januaryRate = (tar.januarySignPrice / tar.januaryTarget).toFixed(2) * 100
                  tar.januaryStateOneSignPrice = idx === 0 ? 0 : tar.januaryStateOneSignPrice
                  tar.januaryStateOneSignPrice += stateOneSignPrice
                } else if (Number(s.month) === 2) {
                  tar.februarySignPrice = idx === 0 ? 0 : tar.februarySignPrice
                  tar.februarySignPrice += signPrice
                  tar.februaryRate = (tar.februarySignPrice / tar.februaryTarget).toFixed(2) * 100
                  tar.februaryStateOneSignPrice = idx === 0 ? 0 : tar.februaryStateOneSignPrice
                  tar.februaryStateOneSignPrice += stateOneSignPrice
                } else if (Number(month) === 3) {
                  tar.marchSignPrice = idx === 0 ? 0 : tar.marchSignPrice
                  tar.marchSignPrice += signPrice
                  tar.marchRate = (tar.marchSignPrice / tar.marchTarget).toFixed(2) * 100
                  tar.marchStateOneSignPrice = idx === 0 ? 0 : tar.marchStateOneSignPrice
                  tar.marchStateOneSignPrice += stateOneSignPrice
                } else if (Number(month) === 4) {
                  tar.aprilSignPrice = idx === 0 ? 0 : tar.aprilSignPrice
                  tar.aprilSignPrice += signPrice
                  tar.aprilRate = (tar.aprilSignPrice / tar.aprilTarget).toFixed(2) * 100
                  tar.aprilStateOneSignPrice = idx === 0 ? 0 : tar.aprilStateOneSignPrice
                  tar.aprilStateOneSignPrice += stateOneSignPrice
                } else if (Number(month) === 5) {
                  tar.maySignPrice = idx === 0 ? 0 : tar.maySignPrice
                  tar.maySignPrice += signPrice
                  tar.mayRate = (tar.maySignPrice / tar.mayTarget).toFixed(2) * 100
                  tar.mayStateOneSignPrice = idx === 0 ? 0 : tar.mayStateOneSignPrice
                  tar.mayStateOneSignPrice += stateOneSignPrice
                } else if (Number(month) === 6) {
                  tar.juneSignPrice = idx === 0 ? 0 : tar.juneSignPrice
                  tar.juneSignPrice += signPrice
                  tar.juneRate = (tar.juneSignPrice / tar.juneTarget).toFixed(2) * 100
                  tar.juneStateOneSignPrice = idx === 0 ? 0 : tar.juneStateOneSignPrice
                  tar.juneStateOneSignPrice += stateOneSignPrice
                } else if (Number(month) === 7) {
                  tar.julySignPrice = idx === 0 ? 0 : tar.julySignPrice
                  tar.julySignPrice += signPrice
                  tar.julyRate = (tar.julySignPrice / tar.julyTarget).toFixed(2) * 100
                  tar.julyStateOneSignPrice = idx === 0 ? 0 : tar.julyStateOneSignPrice
                  tar.julyStateOneSignPrice += stateOneSignPrice
                } else if (Number(month) === 8) {
                  tar.augustSignPrice = idx === 0 ? 0 : tar.augustSignPrice
                  tar.augustSignPrice += signPrice
                  tar.augustRate = (tar.augustSignPrice / tar.augustTarget).toFixed(2) * 100
                  tar.augustStateOneSignPrice = idx === 0 ? 0 : tar.augustStateOneSignPrice
                  tar.augustStateOneSignPrice += stateOneSignPrice
                } else if (Number(month) === 9) {
                  tar.septemberSignPrice = idx === 0 ? 0 : tar.septemberSignPrice
                  tar.septemberSignPrice += signPrice
                  tar.septemberRate = (tar.septemberSignPrice / tar.septemberTarget).toFixed(2) * 100
                  tar.septemberStateOneSignPrice = idx === 0 ? 0 : tar.septemberStateOneSignPrice
                  tar.septemberStateOneSignPrice += stateOneSignPrice
                } else if (Number(s.month) === 10) {
                  tar.octoberSignPrice = idx === 0 ? 0 : tar.octoberSignPrice
                  tar.octoberSignPrice += signPrice
                  tar.octoberRate = (tar.octoberSignPrice / tar.octoberTarget).toFixed(2) * 100
                  tar.octoberStateOneSignPrice = idx === 0 ? 0 : tar.octoberStateOneSignPrice
                  tar.octoberStateOneSignPrice += stateOneSignPrice
                } else if (Number(month) === 11) {
                  tar.novemberSignPrice = idx === 0 ? 0 : tar.novemberSignPrice
                  tar.novemberSignPrice += signPrice
                  tar.novemberRate = (tar.novemberSignPrice / tar.novemberTarget).toFixed(2) * 100
                  tar.novemberStateOneSignPrice = idx === 0 ? 0 : tar.novemberStateOneignPrice
                  tar.novemberStateOneSignPrice += stateOneSignPrice
                } else if (Number(month) === 12) {
                  tar.decemberSignPrice = idx === 0 ? 0 : tar.decemberSignPrice
                  tar.decemberSignPrice += signPrice
                  tar.decemberRate = (tar.decemberSignPrice / tar.decemberTarget).toFixed(2) * 100
                  tar.decemberStateOneSignPrice = idx === 0 ? 0 : tar.decemberStateOneSignPrice
                  tar.decemberStateOneSignPrice += stateOneSignPrice
                }
              }
            })
          })
        }
      },
      setMonth (tar, s) {
        if (Number(s.month) === 1) {
          tar.januarySignPrice = s.signPrice || 0
          tar.januaryStateOneSignPrice = s.stateOneSignPrice || 0
          tar.januaryRate = (s.signPrice / tar.januaryTarget).toFixed(2) * 100
          tar.allSignPrice += tar.januarySignPrice
          tar.allStateOneSignPrice += tar.januaryStateOneSignPrice
        } else if (Number(s.month) === 2) {
          tar.februarySignPrice = s.signPrice || 0
          tar.februaryStateOneSignPrice = s.stateOneSignPrice || 0
          tar.februaryRate = (s.signPrice / tar.februaryTarget).toFixed(2) * 100
          tar.allSignPrice += tar.februarySignPrice
          tar.allStateOneSignPrice += tar.februaryStateOneSignPrice
        } else if (Number(s.month) === 3) {
          tar.marchSignPrice = s.signPrice || 0
          tar.marchStateOneSignPrice = s.stateOneSignPrice || 0
          tar.marchRate = (s.signPrice / tar.marchTarget).toFixed(2) * 100
          tar.allSignPrice += tar.marchSignPrice
          tar.allStateOneSignPrice += tar.marchStateOneSignPrice
        } else if (Number(s.month) === 4) {
          tar.aprilSignPrice = s.signPrice || 0
          tar.aprilStateOneSignPrice = s.stateOneSignPrice || 0
          tar.aprilRate = (s.signPrice / tar.aprilTarget).toFixed(2) * 100
          tar.allSignPrice += tar.aprilSignPrice
          tar.allStateOneSignPrice += tar.aprilStateOneSignPrice
        } else if (Number(s.month) === 5) {
          tar.maySignPrice = s.signPrice || 0
          tar.mayStateOneSignPrice = s.stateOneSignPrice || 0
          tar.mayRate = (s.signPrice / tar.mayTarget).toFixed(2) * 100
          tar.allSignPrice += tar.maySignPrice
          tar.allStateOneSignPrice += tar.mayStateOneSignPrice
        } else if (Number(s.month) === 6) {
          tar.juneSignPrice = s.signPrice || 0
          tar.juneStateOneSignPrice = s.stateOneSignPrice || 0
          tar.juneRate = (s.signPrice / tar.juneTarget).toFixed(2) * 100
          tar.allSignPrice += tar.juneSignPrice
          tar.allStateOneSignPrice += tar.juneStateOneSignPrice
        } else if (Number(s.month) === 7) {
          tar.julySignPrice = s.signPrice || 0
          tar.julyStateOneSignPrice = s.stateOneSignPrice || 0
          tar.julyRate = (s.signPrice / tar.julyTarget).toFixed(2) * 100
          tar.allSignPrice += tar.julySignPrice
          tar.allStateOneSignPrice += tar.julyStateOneSignPrice
        } else if (Number(s.month) === 8) {
          tar.augustSignPrice = s.signPrice || 0
          tar.augustStateOneSignPrice = s.stateOneSignPrice || 0
          tar.augustRate = (s.signPrice / tar.augustTarget).toFixed(2) * 100
          tar.allSignPrice += tar.augustSignPrice
          tar.allStateOneSignPrice += tar.augustStateOneSignPrice
        } else if (Number(s.month) === 9) {
          tar.septemberSignPrice = s.signPrice || 0
          tar.septemberStateOneSignPrice = s.stateOneSignPrice || 0
          tar.septemberRate = (s.signPrice / tar.septemberTarget).toFixed(2) * 100
          tar.allSignPrice += tar.septemberSignPrice
          tar.allStateOneSignPrice += tar.septemberStateOneSignPrice
        } else if (Number(s.month) === 10) {
          tar.octoberSignPrice = s.signPrice || 0
          tar.octoberStateOneSignPrice = s.stateOneSignPrice || 0
          tar.octoberRate = (s.signPrice / tar.octoberTarget).toFixed(2) * 100
          tar.allSignPrice += tar.octoberSignPrice
          tar.allStateOneSignPrice += tar.octoberStateOneSignPrice
        } else if (Number(s.month) === 11) {
          tar.novemberSignPrice = s.signPrice || 0
          tar.novemberStateOneSignPrice = s.stateOneSignPrice || 0
          tar.novemberRate = (s.signPrice / tar.novemberTarget).toFixed(2) * 100
          tar.allSignPrice += tar.novemberSignPrice
          tar.allStateOneSignPrice += tar.novemberStateOneSignPrice
        } else if (Number(s.month) === 12) {
          tar.decemberSignPrice = s.signPrice || 0
          tar.decemberStateOneSignPrice = s.stateOneSignPrice || 0
          tar.decemberRate = (s.signPrice / tar.decemberTarget).toFixed(2) * 100
          tar.allSignPrice += tar.decemberSignPrice
          tar.allStateOneSignPrice += tar.decemberStateOneSignPrice
        }
      }
    },
    created () {
      this.statis()
    }
  }
</script>
